/* GS://PROTOCOLO
 * Arquivo: src/pages/admin/UserListTable.js
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema GoldenSisters
 * Versão: 3.1 – Remoção de Acesso Financeiro Rápido
 * Impacto da Versão: [src/pages/admin/UserListTable.js]
 * Data: 15/01/2026
 * Responsável: Gemini (conforme Protocolo)
 *
 * Mudanças desta versão:
 * - REMOVIDO: Botão "Wallet" e importação do ícone DollarSign.
 * - MANTIDO: Funcionalidade de edição (botão Editar).
 */

import React from 'react';
import { Edit } from 'lucide-react'; // REMOVIDO: DollarSign

const UserListTable = ({ users, isLoading, error, onEditUser, onAdjustPoints }) => { 
  if (isLoading) {
    return <div className="text-center p-8 bg-gray-800 rounded-lg"><p className="text-white">Carregando usuários...</p></div>;
  }

  if (error) {
    return <div className="text-center p-8 bg-red-900 text-white rounded-lg"><p>Falha ao carregar usuários.</p><p className="text-sm mt-2">{error}</p></div>;
  }

  return (
    <div className="bg-gray-800 shadow-md rounded-lg overflow-hidden">
      <h3 className="text-xl font-bold text-white p-4 border-b border-gray-700">Equipe e Usuários</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-700">
          <thead className="bg-gray-700">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Email</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Papel (Role)</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Data de Criação</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Ações</th>
            </tr>
          </thead>
          <tbody className="bg-gray-800 divide-y divide-gray-700">
            {users.length > 0 ? (
              users.map((user) => (
                <tr key={user.uid}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-white">{user.displayName || 'Sem Nome'}</div>
                    <div className="text-sm text-gray-400">{user.email}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300 capitalize">{user.role || 'user'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">
                    {user.creationTime ? new Date(user.creationTime).toLocaleDateString('pt-BR') : '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex items-center">
                    <button 
                      onClick={() => onEditUser(user)} 
                      className="text-indigo-400 hover:text-indigo-300 flex items-center mr-4"
                      title="Editar Dados"
                    >
                      <Edit className="w-4 h-4 mr-2" />
                      Editar
                    </button>
                    {/* REMOVIDO: Botão Wallet foi retirado conforme solicitação */}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-8 text-gray-500">Nenhum usuário encontrado.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserListTable;